import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { colors, heading4, spacing, extraLargeShadow } from 'ui/theme';
import { NavBarVariant } from './NavBar.types';

const MIN_HEIGHT = pxToRem(64);

const NAV_BAR_THEME = {
  [NavBarVariant.Edit]: {
    backgroundColor: colors.purple100,
    color: colors.white,
  },
  [NavBarVariant.Focus]: {
    backgroundColor: colors.white,
    color: colors.textPrimary,
  },
};

export const NavBarContainer = styled.div<{ variant: NavBarVariant }>`
  background-color: ${({ variant }) => NAV_BAR_THEME[variant].backgroundColor};
  display: flex;
  min-height: ${MIN_HEIGHT};
  padding: 0 ${spacing.plusHalf};
  align-items: center;
  flex-shrink: 0;
  justify-content: space-between;
  ${extraLargeShadow}
`;

export const NavContent = styled.div`
  display: flex;
  gap: ${spacing.half};
  align-items: center;
`;

export const Title = styled.h2<{ variant: NavBarVariant }>`
  margin: 0;
  ${heading4}
  color: ${({ variant }) => NAV_BAR_THEME[variant].color};
`;
